<template>
  <div>
    <el-container>
      <el-header>
        <head_page :head_page_type="false" ref="head_page"></head_page>
      </el-header>
      <el-main>
        <div id='choose_city' v-loading="loading" v-bind:element-loading-text="$t('message.Desperately_loading')"
          element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
          <head_menu :has-back=true @go-back-click="goBack" :has-next=true @go-next-click="goNext">
            <template #title>
              <div style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </div>
            </template>
          </head_menu>
          <!--
          <div style="text-align: left;">
            <el-row>
              <el-col :span="8" style="background-color: #F0F0EE;">
                <el-button-group>
                  <el-button icon="el-icon-d-arrow-left" @click="goBack" style="background-color: #f3f3f4;"></el-button>
                  <el-button icon="el-icon-s-home" @click="goHome" style="background-color: #e9e9ea;"></el-button>
                  <el-button icon="el-icon-d-arrow-right" @click="goNext" style="background-color: #f3f3f4;"></el-button>
                </el-button-group>
              </el-col>
              <el-col :span="6" style="text-align:center;background-color: #F0F0EE;color:#53ADBC;padding:10px;font-size: 20px;">
                {{chosen_city_shown}}
              </el-col>
              <el-col :span="10" style="text-align: right;background-color: #F0F0EE;">
              </el-col>
            </el-row>
          </div>
          -->
          <!--<div class="first-line" style="display:flex;align-items:stretch;justify-items:space-between">-->
          <el-row type="flex" :gutter="20">
            <!--<div style="text-align: left;width:40%" id="selected_criterias">-->
            <el-col :span="8" style="background: white; background-clip: content-box; border-radius: 0; padding-left: 30px;">
              <div style="text-align: left; margin-top: 10px;" id ='selected_criterias'>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Gender") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ gender }}</p>
                  </el-col>
                </el-row>

                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Age") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ age }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Spend_Power") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ spend_power }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Interests") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ interest }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.POI") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ poi }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Media_Format") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ media_type }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Rank") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ rank }}</p>
                  </el-col>
                </el-row>
                <el-row :gutter="10" style="margin: 15px">
                  <el-col :span="7">
                    <p class="p9">{{ $t("message.Nearby_Location") }}:</p>
                  </el-col>
                  <el-col :span="17">
                    <p class="p10">{{ poi_ba_label_selection_list }}</p>
                  </el-col>
                </el-row>
              </div>
            <!--</div>-->
            </el-col>

            <el-col :span="16" style="background: white; background-clip: content-box; border-radius: 0; padding-right: 30px;">
              <div style="padding: 5px;font-size: 18px;color:#254A6E;font-weight: 600;margin-bottom:10px">
                  <span>{{$t('message.Campaign_Starting_Date')}} {{this.campaignDate_YYMMDD}}</span>
                  <span style="margin-left:15px"
                          >{{$t('message.Duration(Months)')}} : {{this.campaignDuration}}</span>
              </div>
              <!--
              <el-tabs type="border-card" stretch>
                <el-tab-pane :label="$t('message.Package_Index_Distribution')">
                  <apexchart v-if ="lang=='en'" ref="donutIndex" width="50%" height="300" type="donut" :options="chartOptionsIndexEn" :series="seriesIndex" ></apexchart>
                  <apexchart v-if ="lang=='cn'" ref="donutIndex" width="50%" height="300" type="donut" :options="chartOptionsIndexCn" :series="seriesIndex" ></apexchart>
                </el-tab-pane>
                <el-tab-pane :label="$t('message.Package_Grade_Distribution')">
                  <apexchart ref="donutGrade" width="400" height="300" type="donut" :options="chartOptionsGrading" :series="seriesGrade"></apexchart>
                </el-tab-pane>
              </el-tabs>
              -->
              <el-row>
                <el-col :span="12">
                  <el-card class="box-card" shadow="never" :body-style="{padding: '0px', margin: '0 0 15px 0'}">
                    <div class="card-header">
                      <span>{{$t('message.Package_Index_Distribution')}}</span>
                    </div>
                    <apexchart v-if ="$i18n.locale=='en'" ref="donutIndex" width="350" height="300" type="donut" :options="chartOptionsIndexEn" :series="seriesIndex" ></apexchart>
                    <apexchart v-if ="$i18n.locale=='cn'" ref="donutIndex" width="350" height="300" type="donut" :options="chartOptionsIndexCn" :series="seriesIndex" ></apexchart>
                  </el-card>
                </el-col>
                <el-col :span="12">
                  <el-card class="box-card" shadow="never" :body-style="{padding: '0px', margin: '0 0 15px 0'}">
                    <div class="card-header">
                      <span>{{$t('message.Package_Grade_Distribution')}}</span>
                    </div>
                    <apexchart ref="donutGrade" width="350" height="300" type="donut" :options="chartOptionsGrading" :series="seriesGrade"></apexchart>
                  </el-card>
                </el-col>
              </el-row>
            </el-col>
          <!--</div>-->
          </el-row>

          <el-row type="flex" :gutter="20" style="justify-content: center;">
            <div style="text-align: right;width:calc(100% - 60px);display:flex;justify-content:center;align-items:center;border:1px dashed blue">
              <span style="font-size:2em;margin:30px;margin-top:10px;margin-bottom:10px">{{ $t("message.Final_Package_Cost") }}: </span>
              <span style="font-size:2em;margin:10px;margin-left:30px">{{final_package_cost.toLocaleString()}}</span>
              <el-button type="primary" @click="drawer = true" style="right:0;bottom:0">
                {{ $t("message.Give_it_a_price") }}
              </el-button>
            </div>
          </el-row>
          
          <div class="second-line" style="margin:20px;display:flex;align-items:stretch;justify-items:space-between">
            <el-table :data="tableDataCommercial" fit style="width: 100%;">
                <el-table-column prop="bus_name" v-bind:label="$t('message.Bus_Line')" width="120">
                </el-table-column>
                <el-table-column prop="vendor_name" v-bind:label="$t('message.vendor')" width="120">
                </el-table-column>
                <el-table-column prop="related_poi_nb" v-bind:label="$t('message.Related_Location_Number')" width="120">
                </el-table-column>
                <el-table-column prop="rate" v-bind:label="$t('message.index2')" width="120">
                </el-table-column>
                <el-table-column prop="bus_quantity" v-bind:label="$t('message.Bus_Quantity')" align="center" width="100">
                </el-table-column>
                <el-table-column prop="rank" v-bind:label="$t('message.Grading')" width="120">
                </el-table-column>
                <el-table-column v-if ="$i18n.locale=='en'" prop="media_type_label" v-bind:label="$t('message.Media_Format')" width="220">
                </el-table-column>
                <el-table-column v-if ="$i18n.locale=='cn'" prop="media_type_label" v-bind:label="$t('message.Media_Format')" width="220">
                </el-table-column>
                <el-table-column prop="duration" v-bind:label="$t('message.Duration3')" align="center" width="80">
                </el-table-column>
                <!-- <el-table-column v-if="ifRankExists" prop="rate_card" v-bind:label="$t('message.Media_Cost')" align="right">
                </el-table-column>
                <el-table-column v-if="ifRankExists" prop="price" v-bind:label="$t('message.Total_Media_Cost')" align="right">
                </el-table-column> -->
                <el-table-column prop="impression_total" v-bind:label="$t('message.Viewed_Impression')" align="right" min-width="160">
                  <template slot-scope="scope1">
                    {{scope1.row.impression_total.toLocaleString('en-US')}}
                  </template>
                </el-table-column>
                <el-table-column v-bind:label="$t('message.Viewed_Impression(Audience)')" align="right" min-width="160">
                  <template slot-scope="scope1">
                    {{scope1.row.adjusted_impression.toLocaleString('en-US')}}
                  </template>
                </el-table-column>
                <el-table-column prop="CPM" v-bind:label="$t('message.CPM')" align="right" min-width="120">
                </el-table-column>
                <el-table-column prop="adjusted_CPM" v-bind:label="$t('message.CPM_Target_Audience_Based')" align="right" min-width="150">
                </el-table-column>
              </el-table>

            

            <el-drawer
              size="50%"
              :visible.sync="drawer"
              :direction="direction"
              ref="drawer"
              :before-close="handleClose">
              <template slot="title">
                <span style="font-size:1.2em;user-select:none">{{$t("message.Calculation")}}</span>
              </template>
              <div>
                <div class="row-drawer">
                  <div class="row-drawer-box">
                    {{$t("message.Total_Media_Cost")}}
                    <div style="margin-top:10px">{{totalMediaCost}}</div>
                  </div>
                  <div class="row-drawer-box">
                    {{$t("message.Media_Cost_Discount")}}
                    <el-input v-model="mediaCostDiscount" @keyup.enter.native="calculateTotalPackageCost">
                      <template slot="append">%</template>
                    </el-input>
                  </div>
                </div>
                <div class="row-drawer">
                  <div class="row-drawer-box">
                    {{$t("message.Total_Production_Cost")}}
                    <div style="margin-top:10px">{{totalProductionCost}}</div>
                  </div>
                  <div class="row-drawer-box">
                    {{$t("message.Product_Cost_Discount")}}
                    <el-input v-model="productionCostDiscount" @keyup.enter.native="calculateTotalPackageCost">
                      <template slot="append">%</template>
                    </el-input>
                  </div>
                </div>
                <div class="row-drawer">
                  <div class="row-drawer-box">
                    {{$t("message.Total_Package_Cost")}}
                  </div>
                  <div class="row-drawer-box">
                    {{totalPackageCost}}
                  </div>
                </div>
                <div class="row-drawer">
                  <div class="row-drawer-box">
                    {{$t("message.Round_Up_Cost")}}
                  </div>
                  <div class="row-drawer-box">
                    <el-input-number v-model="roundUpCost" @change="handleChangeRoundUpCost"></el-input-number>
                  </div>
                </div>
              </div>
              <div class="row-drawer">
                <div class="row-drawer-box">
                  {{$t("message.Final_Package_Cost")}}(¥)
                </div>
                <div class="row-drawer-box">
                  <el-input v-model="final_package_cost" @change="handleChangefinal_package_cost"></el-input>
                </div>
              </div>
              <div class="row-drawer">
                <div class="row-drawer-box" style="visible:none">
                  <el-button style="display:inline-block" type="primary" plain @click="calculateTotalPackageCost">{{$t("message.Calculation")}}</el-button>
                </div>
              </div>
              <el-table :data="tableDrawer" fit style="width: 100%;" row-key="name">
                <el-table-column prop="name">
                </el-table-column>
                <el-table-column prop="impression" v-bind:label="$t('message.Impression')">
                  <template slot-scope="scope1">
                    {{scope1.row.impression.toLocaleString('en-US')}}
                  </template>
                </el-table-column>
                <el-table-column prop="ratecardCPM" v-bind:label="$t('message.Ratecard_CPM')" align="right">
                </el-table-column>
                <el-table-column prop="packageCPM" v-bind:label="$t('message.Package_CPM')">
                </el-table-column>
              </el-table>
              <div class="row-drawer">
                <div class="row-drawer-box" style="visible:none;margin:20px">
                  <el-button style="display:inline-block" type="primary" plain @click="$refs.drawer.closeDrawer()">{{$t("message.Next")}}</el-button>
                </div>
              </div>
            </el-drawer>
          </div>

          
          <div style="clear: both;">
            <el-row type="flex" class="row-bg" justify="space-between">
              <el-col :span="4">
                <div style="background-color: #909399">
                  <p class="p_navi_button" v-on:click="goBack">
                    {{ $t("message.Back") }}
                  </p>
                </div>
              </el-col>

              <el-col :span="8">
                <div></div>
              </el-col>

              <el-col :span="4">
                <div style="background-color: #909399"  @click="goNext">
                  <p class="p_navi_button">
                    {{ $t("message.Next") }}
                  </p>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import head_page from "./components/head_page.vue";
import head_menu from "./components/head_menu.vue";
import axios from "axios";
import _global from "./components/global.vue";
export default {
  name: "package_selection",
  data() {
    return {
      productionCostDiscount:100,
      totalProductionCost:0,
      input:0,
      tableDrawer:[],
      final_package_cost:0,
      totalMediaCost:110000,
      totalPackageCost:0,
      mediaCostDiscount:100,
      tableDataCommercial:[],
      roundUpCost: 0,
      drawer: false,
      direction: 'rtl',
      lang: "en",
      chosen_city: "",
      loading:false,
      options: {},
      information: {},
      gender: null,
      age: null,
      spend_power: null,
      interest: null,
      poi: null,
      media_type: null,
      rank: null,
      rank_option:[],
      campaignDate: null,
      campaignDate_YYMMDD:null,
      campaignDuration: null,
      poi_ba_label_selection_list: [],
      poi_ba_value_selection_list: [],
      dataInfo: {},
      selectedBusLineTop: [],
      selectedBusLineMediumUp: [],
      selectedBusLineMediumDown: [],
      selectedBusLineLow: [],
      busbody:[1,2,3,4,5],
      seriesIndex:[12,4,2,4],
      seriesGrade:[14,2,1,5],
      summaryTable:{},
      chartOptionsIndexCn:{
        colors: ["#5CA39A", "#7CB6AF", "#9CC9C4", "#BCDCD8"],
        labels: ['极佳', '优秀', '较好', '普通'],
        dataLabels: {
          // formatter(val, opts) {
          //   const name = opts.w.globals.labels[opts.seriesIndex]
          //   val = opts.w.config.series[opts.seriesIndex]
          //   return [name, val]
          // }
          style: {
            colors: ["#FFFFFF"],
          }
        },
        legend: {
          show: true,
          position:'bottom',
          horizontalAlign: 'center',
        },
      },
      chartOptionsIndexEn:{
        colors: ["#5CA39A", "#7CB6AF", "#9CC9C4", "#BCDCD8"],
        labels: ['Top', 'Avg+', 'Avg-', 'Low'],
        dataLabels: {
          // formatter(val, opts) {
          //   const name = opts.w.globals.labels[opts.seriesIndex]
          //   val = opts.w.config.series[opts.seriesIndex]
          //   return [name, val]
          // }
          style: {
            colors: ["#FFFFFF"],
          }
        },
        legend: {
          show: true,
          position:'bottom',
          horizontalAlign: 'center', 
        },
      },
      chartOptionsGrading:{
        colors: ["#9D9D9D", "#818682", "#696B6A", "#515151"],
        labels: ['S', 'A++', 'A+', 'A'],
        legend: {
          show: true,
          position:'bottom',
          horizontalAlign: 'center',
        },
        dataLabels: {
          // formatter(val, opts) {
          //   const name = opts.w.globals.labels[opts.seriesIndex]
          //   val = opts.w.config.series[opts.seriesIndex]
          //   return [name, val]
          // }
          style: {
            colors: ["#FFFFFF"],
          }
        },
      },
      tableDataCommercial:[],
      totalImpression:0,
      totalTargetImpression:0,
    };
  },
  computed:{
    chosen_city_shown: function () {
      let tmp = "message." + this.chosen_city;
      return this.$t(tmp);
    },
    localLang() {
      return this.$i18n.locale;
    }
  },
  components: {
    head_page,
    head_menu,
  },
  watch:{
    localLang() {
      this.fillData_Info();
      for (let ele of this.tableDataCommercial) {
        ele.media_type_label = this.media_type
      }
    }
  },
  created() {
    if (JSON.parse(sessionStorage.getItem("User")) != null) {
      this.user = JSON.parse(sessionStorage.getItem("User"))
        .split(".")[0]
        .toUpperCase();
    }
    this.chosen_city = this.$route.query.chosen_city;
  },
  mounted() {
    this.lang = JSON.parse(sessionStorage.getItem("lang"));
    this.$refs.head_page.switchLang(this.lang);
    this.$refs.head_page.update_user_name();
    this.$i18n.locale = this.lang;
    this.adjustTableDataCommercial()
    this.fillData_Options();
    this.fillData_Info();
    this.getBusLineData();
    
    setTimeout(() => {
      this.updateChart()
    }, 1)
    /*
    this.updateChart()
    */
    this.calculateTotalPackageCost()
  },
  methods: {
    handleChangefinal_package_cost(){
      this.roundUpCost= this.final_package_cost - Number(this.totalPackageCost)
      this.tableDrawer[0].packageCPM = Number(this.final_package_cost/this.totalImpression*1000).toFixed(2)
      this.tableDrawer[1].packageCPM = Number(this.final_package_cost/this.totalTargetImpression*1000).toFixed(2)
      this.tableDrawer.splice(1,0);
      // this.$set(this.tableDrawer[0],"packageCPM",1)
      // this.$forceUpdate();
    },
    calculateTotalPackageCost(){
      this.totalPackageCost = Number((Number(this.mediaCostDiscount) * Number(this.totalMediaCost) + Number(this.productionCostDiscount) * Number(this.totalProductionCost))/100).toFixed(0)
      this.final_package_cost =Number(this.totalPackageCost)+Number(this.roundUpCost)
      let obj ={}
      obj.name= "Total Audience"
      obj.impression = this.totalImpression
      obj.ratecardCPM = Number(this.totalMediaCost/this.totalImpression*1000).toFixed(2)
      obj.packageCPM = Number(this.final_package_cost/this.totalImpression*1000).toFixed(2)
      this.tableDrawer[0]=obj
      let obj1 ={}
      obj1.name= "Target Audience"
      obj1.impression = this.totalTargetImpression
      obj1.ratecardCPM = Number(this.totalMediaCost/this.totalTargetImpression*1000).toFixed(2)
      obj1.packageCPM = Number(this.final_package_cost/this.totalTargetImpression*1000).toFixed(2)
      this.tableDrawer[1]=obj1

      this.tableDrawer[0].packageCPM = Number(this.final_package_cost/this.totalImpression*1000).toFixed(2)
      this.tableDrawer[1].packageCPM = Number(this.final_package_cost/this.totalTargetImpression*1000).toFixed(2)
      this.tableDrawer.splice(1,0);
    },
    handleClose(done){
      done();
    },
    ifNull(a){
      if (a == null){
        a=[]
      }
      return a
    },
    repeatRatio(bus_body){
      // Bus body repeat Ratio is x^0.75/x round to 3 demical
      return (Math.pow(bus_body,0.75)/bus_body).toFixed(3)
    },
    adjustTableDataCommercial(){
      let selectedBusLineTop = this.ifNull(this.$store.state.package.package_selection.selectedBusLineTop)
      let selectedBusLineMediumUp = this.ifNull(this.$store.state.package.package_selection.selectedBusLineMediumUp)
      let selectedBusLineMediumDown = this.ifNull(this.$store.state.package.package_selection.selectedBusLineMediumDown)
      let selectedBusLineLow = this.ifNull(this.$store.state.package.package_selection.selectedBusLineLow)
      let campaignDuration = this.$store.state.package.package_selection.campaignDuration
      let media_type = this.$store.state.package.package_selection.media_type
      let obj={}
      let tables=selectedBusLineTop.concat(selectedBusLineMediumUp,selectedBusLineMediumDown,selectedBusLineLow)
      this.$store.state.package.package_selection.tables=tables
      let totalTargetImpression = 0
      let totalImpression = 0
      let totalMediaCost=0
      let totalProductionCost=0
      for (let ele of tables){
        obj={}
        obj.bus_id =ele.bus_id.split('_')[1]
        obj.bus_name =ele.bus_name
        obj.related_poi_nb = ele.related_poi_nb
        obj.rate = Number(ele.value_rating*100).toFixed(0)
        obj.bus_quantity = ele.body_qty
        obj.rank = ele.rank_tag
        obj.media_type_label =media_type
        obj.vendor_name =ele.vendor_name
        obj.duration = campaignDuration
        obj.impression_total = Math.round(ele.IMP * this.repeatRatio(ele.body_qty) * ele.body_qty)
        obj.adjusted_impression = Math.round(ele.target_IMP * this.repeatRatio(ele.body_qty) * ele.body_qty)
        obj.media_cost = ele.media_cost
        obj.production_cost = ele.production_cost
        //cpm changed because of repeat ratio
        obj.CPM = ((obj.media_cost * obj.bus_quantity * obj.duration)/obj.impression_total*1000).toFixed(2)
        obj.adjusted_CPM = ((obj.media_cost * obj.bus_quantity * obj.duration)/obj.adjusted_impression*1000).toFixed(2)
        totalTargetImpression +=obj.adjusted_impression
        totalImpression +=obj.impression_total
        this.tableDataCommercial.push(obj)
        totalMediaCost +=obj.media_cost*obj.bus_quantity
        totalProductionCost +=obj.production_cost*obj.bus_quantity
      }
      totalMediaCost = totalMediaCost*campaignDuration
      this.totalTargetImpression=totalTargetImpression
      this.totalImpression=totalImpression
      this.totalMediaCost = totalMediaCost
      this.totalProductionCost = totalProductionCost

    },
    handleChangeRoundUpCost(value) {
      this.final_package_cost = Number(this.totalPackageCost)+Number(this.roundUpCost)
      this.tableDrawer[0].packageCPM = Number(this.final_package_cost/this.totalImpression*1000).toFixed(2)
      this.tableDrawer[1].packageCPM = Number(this.final_package_cost/this.totalTargetImpression*1000).toFixed(2)
      this.tableDrawer.splice(1,0);
    },
    goBack: function (event) {
      this.$router.back()
    },
    goHome: function (event) {
      this.$router.push({
        path: "/choose_city",
      });
      let lang = JSON.parse(sessionStorage.getItem("lang"));
      let user = JSON.parse(sessionStorage.getItem("User"));
      let UserAuthority = JSON.parse(sessionStorage.getItem("UserAuthority"));
      sessionStorage.clear();
      sessionStorage.setItem("lang", JSON.stringify(lang));
      sessionStorage.setItem("User", JSON.stringify(user));
      sessionStorage.setItem("UserAuthority", JSON.stringify(UserAuthority));
      //set null when out of package
      this.$store.state.package.edit = {}
    },
    fillData_Options() {
      //this.options = JSON.parse(sessionStorage.getItem('Data_Options'));
      this.options = this.$store.state.package.Data_Options;
    },
    fillData_Info() {
      //this.information = JSON.parse(sessionStorage.getItem('Data_Information'));
      this.information = this.$store.state.package.Data_Information;
      let gender = this.information["data_audience"].value_gender;
      let age = this.information["data_audience"].value_age;
      let spend_power = this.information["data_audience"].value_spend_power;
      let interest = this.information["data_audience"].value_interest;
      let gender_options = this.options["audience_options"]["gender_options"];
      let age_options = this.options["audience_options"]["age_options"];
      let spend_power_options = this.options["audience_options"][
        "spend_power_options"
      ];
      let interest_options = this.options["audience_options"][
        "interest_options"
      ];

      this.poi_ba_value_selection_list = this.information[
        "poi_ba_value_selection_list"
      ];
      let poi_ba_label_selection_list = this.information[
        "poi_ba_label_selection_list"
      ];

      this.gender = this.changeDataToText(gender, gender_options);
      this.age = this.changeDataToText(age, age_options);
      this.spend_power = this.changeDataToText(
        spend_power,
        spend_power_options
      );
      this.interest = this.changeDataToText(interest, interest_options);
      this.poi = this.changeDataToText_poi(this.information["data_poi"]);
      this.media_type = this.changeDataToText(
        this.information["data_media_rank"].value_media_format,
        this.options["media_rank_options"].media_format_options
      );
      this.rank = this.changeDataToText(
        this.information["data_media_rank"].value_rank,
        this.options["media_rank_options"].rank_options
      );
      if (this.rank != "") this.ifRank = true;

      this.rank_options = []
      for (let ele in this.options.media_rank_options.rank_options){
        this.rank_options.push(this.options.media_rank_options.rank_options[ele].label)
      }

      this.campaignDate = new Date(this.information.date)
      this.campaignDate_YYMMDD = this.campaignDate.getFullYear()+'/'+(Number(this.campaignDate.getMonth())+1).toString()+'/'+this.campaignDate.getDate();
      this.campaignDuration = this.information.value_duration;

      this.poi_ba_label_selection_list = this.changeDataToText_PoiSearch(
        poi_ba_label_selection_list
      );
    },

    changeDataToText_poi(poi) {
      let str = "";
      if (poi.checked_business == true) {
        str = str + this.$t("message.BUSINESS") + " ";
      }
      if (poi.checked_entertainment == true) {
        str = str + this.$t("message.ENTERTAINEMENT") + " ";
      }
      if (poi.checked_living == true) {
        str = str + this.$t("message.LIVING") + " ";
      }
      if (poi.checked_trip == true) {
        str = str + this.$t("message.TRIP");
      }
      return str;
    },

    changeDataToText(data, options) {
      let obj = "";
      if (this.$i18n.locale == "en") {
        if (typeof data == "number") {
          for (let i = 0; i < options.length; i++) {
            if (Number(options[i].value) == data) {
              obj = obj + options[i].label;
            }
          }
        } else if (typeof data == "object") {
          if (data.length > 1) {
            data = data.sort();
          }

          for (let d in data) {
            for (let op in options) {
              if (Number(data[d]) == Number(options[op].value)) {
                obj = obj + String(options[op].label) + " ";
              }
            }
          }
        }
      } else if (this.$i18n.locale == "cn") {
        if (typeof data == "number") {
          for (let i = 0; i < options.length; i++) {
            if (Number(options[i].value) == data) {
              obj = obj + options[i].label_cn;
            }
          }
        } else if (typeof data == "object") {
          if (data.length > 1) {
            data = data.sort();
          }

          for (let d in data) {
            for (let op in options) {
              if (Number(data[d]) == Number(options[op].value)) {
                obj = obj + String(options[op].label_cn) + " ";
              }
            }
          }
        }
      }
      return obj;
    },
    changeDataToText_PoiSearch(poi_ba_label_selection_list) {
      let poi_ba_label_selection_list_text = "";
      for (let index in poi_ba_label_selection_list) {
        poi_ba_label_selection_list_text =
          poi_ba_label_selection_list_text +
          poi_ba_label_selection_list[index] +
          " ";
      }
      return poi_ba_label_selection_list_text;
    },

    getBusLineData() {
      //let data = JSON.parse(sessionStorage.getItem('Data_Information'));
      let data = this.$store.state.package.Data_Information;
      delete data.media_format_options;
    },
    updateChart() {
      const distributionIndex = Object.values(this.$store.state.package.package_selection.distributionIndex)
      const distributionGrade = Object.values(this.$store.state.package.package_selection.distributionGrade)

      //this.$refs.donutIndex.updateSeries(distributionIndex)
      this.seriesIndex = distributionIndex
      //this.$refs.donutGrade.updateSeries(distributionGrade)
      this.seriesGrade = distributionGrade
    },

    goNext(){
      // this.$store.state.package.package_selection.selectedBusLineTop=this.selectedBusLineTop
      // this.$store.state.package.package_selection.selectedBusLineMediumUp=this.selectedBusLineMediumUp
      // this.$store.state.package.package_selection.selectedBusLineMediumDown=this.selectedBusLineMediumDown
      // this.$store.state.package.package_selection.selectedBusLineLow=this.selectedBusLineLow
      this.$store.state.package.package_cost.tableDrawer = this.tableDrawer
      this.$store.state.package.package_cost.totalMediaCost = this.totalMediaCost
      this.$store.state.package.package_cost.totalProductionCost = this.totalProductionCost
      this.$store.state.package.package_cost.totalPackageCost = this.totalPackageCost
      this.$store.state.package.package_cost.productionCostDiscount = this.productionCostDiscount
      this.$store.state.package.package_cost.mediaCostDiscount = this.mediaCostDiscount
      this.$store.state.package.package_cost.roundUpCost = this.roundUpCost
      this.$store.state.package.package_cost.final_package_cost = this.final_package_cost

      this.$router.push({
        path: '/package_confirm',
        query: {
          chosen_city: this.$route.query.chosen_city
        }
      })
    }
  },
};
</script>

<style scoped>
  .labelTab{
    font-size: 1.5em;
    display: inline-block;
    margin:20px;
  }
  .el-tabs__item.is-left{
    margin-bottom:10%;
    margin-top:10%;
  }
  .el-tabs__nav-wrap.is-left{
    margin-top:40%;
  }
  .doughnuts{
    display:inline-block;
  }
  .row-drawer{
    display:flex;
    justify-content: space-around;
    margin:5px;
  }
  .row-drawer-box{
    display:inline-box;
    text-align:left;
    width:30%;
  }
  .apexcharts-legend-series {
    text-align: left;
  }
  .card-header{
    padding: 10px;
    border-bottom: 1px solid #EBEEF5;
    box-sizing: border-box;
    font-weight: 600;
    font-size: 14px;
    color: #254a6e;
    background-color: #fff;
    margin-bottom: 10px;
  }
</style>